import classNames from 'classnames'

import { getStoredIsHighContrastMode } from '../../lib/localStorage'

type Props = {
  index: number
  size: number
  label: string
  isCurrentDayStatRow: boolean
  // The "ran out of guesses" row: labelled X, never green.
  isLoss?: boolean
}

export const Progress = ({
  index,
  size,
  label,
  isCurrentDayStatRow,
  isLoss = false,
}: Props) => {
  const isHighContrast = getStoredIsHighContrastMode()
  const currentRowClass = classNames(
    'rounded-sm py-0.5 pr-1.5 text-right text-xs font-bold text-white',
    isCurrentDayStatRow
      ? isLoss
        ? 'bg-slate-700 dark:bg-slate-400 dark:text-slate-900'
        : isHighContrast
        ? 'bg-orange-600'
        : 'bg-green-600'
      : 'bg-slate-500 dark:bg-slate-600'
  )
  return (
    <div className="justify-left m-1 flex">
      <div className="w-2 items-center justify-center font-semibold tabular-nums">
        {isLoss ? 'X' : index + 1}
      </div>
      <div className="ml-2 w-full">
        <div style={{ width: `${8 + size}%` }} className={currentRowClass}>
          {label}
        </div>
      </div>
    </div>
  )
}
